const serviceLinks = [
  { label: '人事制度 適正診断（無料）', href: 'https://products-eight-sand.vercel.app/' },
  { label: '人事制度構築支援', href: 'https://ktpartners.co.jp' },
  { label: '評価制度設計', href: 'https://ktpartners.co.jp' },
  { label: '管理職育成プログラム', href: 'https://ktpartners.co.jp' },
  { label: '組織診断・改善支援', href: 'https://ktpartners.co.jp' },
];

const companyLinks = [
  { label: '会社概要', href: 'https://ktpartners.co.jp' },
  { label: '代表プロフィール', href: 'https://ktpartners.co.jp' },
  { label: '支援実績・事例', href: '#cases' },
  { label: 'よくあるご質問', href: 'https://ktpartners.co.jp' },
  { label: 'プライバシーポリシー', href: 'https://ktpartners.co.jp' },
];

export default function Footer() {
  return (
    <footer
      style={{
        background: '#0D2B55',
        fontFamily: "'Noto Sans JP', sans-serif",
      }}
    >
      <div className="max-w-[1080px] mx-auto px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-10">
          {/* Left: Logo + Contact */}
          <div className="lg:col-span-1">
            <div className="mb-5">
              <img
                src="https://static.readdy.ai/image/0873e0011337c9e0296d99f64c28862c/d23467623ddda8d70b1e06cd480d69ba.png"
                alt="KT Partners ロゴ"
                className="h-9 w-auto object-contain"
              />
            </div>
            <p className="text-white/50 text-xs leading-relaxed mb-5">
              中小・中堅企業の人事制度構築・評価制度設計の専門コンサルティングファーム。
              学術理論×実務知見で、貴社の人事課題を解決します。
            </p>
            <ul className="flex flex-col gap-2">
              <li className="flex items-start gap-2 text-white/60 text-xs">
                <i className="ri-map-pin-line mt-0.5 flex-shrink-0 text-[#2D8EFF]"></i>
                <span>株式会社KT Partners<br />東京都港区虎ノ門3丁目7-5<br />虎ノ門Roots21ビル 9階</span>
              </li>
              <li className="flex items-center gap-2 text-white/60 text-xs">
                <i className="ri-phone-line flex-shrink-0 text-[#2D8EFF]"></i>
                <a href="tel:0364324789" className="hover:text-white transition-colors cursor-pointer">
                  03-6432-4789
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/60 text-xs">
                <i className="ri-global-line flex-shrink-0 text-[#2D8EFF]"></i>
                <a
                  href="https://ktpartners.co.jp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  https://ktpartners.co.jp
                </a>
              </li>
            </ul>
          </div>

          {/* Right: Links */}
          <div className="lg:col-span-2 grid grid-cols-2 gap-8">
            <div>
              <h4 className="text-white text-xs font-bold mb-4 pb-2 border-b border-white/15">
                サービス
              </h4>
              <ul className="flex flex-col gap-2.5">
                {serviceLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : '_self'}
                      rel="noopener noreferrer"
                      className="text-white/55 text-xs hover:text-white transition-colors cursor-pointer flex items-center gap-1.5"
                    >
                      <i className="ri-arrow-right-s-line text-[#2D8EFF]"></i>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white text-xs font-bold mb-4 pb-2 border-b border-white/15">
                会社情報
              </h4>
              <ul className="flex flex-col gap-2.5">
                {companyLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : '_self'}
                      rel="noopener noreferrer"
                      className="text-white/55 text-xs hover:text-white transition-colors cursor-pointer flex items-center gap-1.5"
                    >
                      <i className="ri-arrow-right-s-line text-[#2D8EFF]"></i>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/35 text-xs">
            &copy; 2025 KT Partners, Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://ktpartners.co.jp" target="_blank" rel="noopener noreferrer" className="text-white/35 text-xs hover:text-white/70 transition-colors cursor-pointer">
              プライバシーポリシー
            </a>
            <a href="https://ktpartners.co.jp" target="_blank" rel="noopener noreferrer" className="text-white/35 text-xs hover:text-white/70 transition-colors cursor-pointer">
              利用規約
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
